<template>
  <div>
    <div class="modal modal--welcomeback" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">
        </div>
        <div class="modal__body modal_ti_header">
          <h1>{{ getTranslations.home_modals_resume_game_welcome_back }} {{ userDetails.username }}!</h1>
          <img class="modal_icon_alert" src="static/images/icon-howitworks-play.png"/>

          <p>{{ getTranslations.home_modals_game_in_progress_wait }}</p>

        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'resume-game',
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ResumeGame.vue